module.exports = __webpack_public_path__ + "img/plataformas-hotmart.50970610.svg";